import { render, staticRenderFns } from "./Specialists.vue?vue&type=template&id=7b6ae6ca"
import script from "./Specialists.vue?vue&type=script&lang=js"
export * from "./Specialists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports